import { Grid, Typography, Box } from "@mui/material";

import cabImage from "../../../static/images/revf/cabinets.webp"
import micons from "../../../static/images/revf/New Images/micons.png"
import cabInterface from "../../../static/images/revf/rev_f_cab_view.webp"

const CabinetBanner = () => {
  const textColor = "#000"
  return <Grid id="cabBanner" container sx={{ width: "100%", pt: 0, pb: 0, background: "radial-gradient(circle, rgb(204, 204, 214) 0%, rgb(86, 86, 105) 100%)" }} justifyContent={"center"} >

    <Grid item xs={12} md={12} justifyContent={"center"} alignItems={"center"}>
      <Grid container sx={{ width: "100%" }} alignItems={"center"} justifyContent={"center"}>

        <Grid item xs={12} md={8} alignItems={"center"} sx={{ p: { xs: 4, md: 10 }, pb: "0 !important", color: textColor, }}>
          <Typography variant="h2" sx={{ fontWeight: "bold", textAlign: "center" }}>Cabinet Simulation</Typography>
        </Grid>

        <Grid item xs={12} md={8} alignItems={"center"} sx={{ pl: { xs: 0, md: 10, }, pr: { xs: 0, md: 10, }, color: textColor, }}>
          <Box sx={{ width: { xs: "100vw", md: "100%" } }}>
            <img loading="lazy" fetchpriority="low" alt="AmpSuite - Rev F Cabinet" width="100%" src={cabImage} />
          </Box>
        </Grid>

        <Grid item xs={12} md={8} alignItems={"center"} sx={{ p: { xs: 4, md: 10 }, paddingTop: "0 !important", color: textColor, }}>

          <Typography fontFamily={"montserrat"} sx={{ mt: 2, fontSize: { md: "30px", xs: "16px", textAlign: "center" } }} >
            <p>An amplifier is nothing without a good cabinet, that's why we included not one but two fully modelled cabinets based on an oversized 4x12 and a 2x12.</p>
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: { xs: "100vw", md: "100%" } }}>
            <img loading="lazy" fetchpriority="low" alt="AmpSuite - Rev F Cabinet" width="50%" src={micons} />
          </Box>
          <Typography fontFamily={"montserrat"} sx={{ mt: 2, fontSize: { md: "30px", xs: "16px", textAlign: "center" } }} >
            <p>Each cabinet is captured with a total of 7 studio-grade microphones, giving you almost endless possibilities for shaping your tone.</p>
          </Typography>


        </Grid>

        <Grid item xs={12} md={6} alignItems={"center"} sx={{ p: { xs: 4, md: 10 }, pb: "0 !important", paddingTop: "0 !important", color: textColor, }}>
          <img loading="lazy" fetchpriority="low" alt="AmpSuite - Rev F Cabinet Interface" width="100%" src={cabInterface} />
        </Grid>

        <Grid item xs={12} md={8} alignItems={"center"} sx={{ p: { xs: 4, md: 10 }, paddingTop: "0 !important", color: textColor, }}>

          <Typography fontFamily={"montserrat"} sx={{ mt: 2, fontSize: { md: "30px", xs: "16px", textAlign: "center" } }} >
            <p>Our speaker simulator not only lets you precisely place your virtual microphone in front of the cabinet, but also makes the amplifier respond differently to different loads. Each cabinet truly gives its own sound, even when using your own IRs.</p>
          </Typography>
        </Grid>


      </Grid>
    </Grid >
  </Grid >
}

export default CabinetBanner;
